import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { ContactDetailsDto } from './../../../../../../shared/service-proxies/service-proxies';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { FormControl } from '@angular/forms';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from '@node_modules/rxjs';
import { Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import {
  ActivityDaysServiceProxy,
  ControllingStructureDto,
  CopyControllingStructureToAllActivityDaysInput,
  UpdateControllingStructureForActivityDayInput,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-assign-assets',
  templateUrl: './assets-assign.component.html',
  styleUrls: ['./assets-assign.component.less'],
})
export class AssignAssetsComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  @ViewChild('controlsSelector', { static: true }) controlsSelector: MatSelect;

  @Input() assetsToBeAssigned: any;
  @Input() activityDayId: string;
  @Input() allocatedPersonnel: any;
  @Input() assetCode: any;
  @Input() controllingStructureCode: any;
  @Input() controlDisabled: boolean;

  @Output()
  onAssignedCounterUpdate: EventEmitter<any> = new EventEmitter<any>();

  public filteredAssets: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public controlsFormCtrl: FormControl = new FormControl();
  public controlsFilterForm: FormControl = new FormControl();
  public filteredControls: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public controllingStructure: any = new ControllingStructureDto();
  protected _onDestroy = new Subject<void>();

  isAssetModified = false;

  selectedAssetId;

  constructor(
    injector: Injector,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private cdr: ChangeDetectorRef,
    private _projectService: ProjectService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.selectAsset();
    if (this.assetsToBeAssigned) {
      this.filteredAssets.next(this.assetsToBeAssigned.slice());
      this.cdr.detectChanges();
    }

    this.controlsFilterForm.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterControls();
      });

    this.cdr.detectChanges();
  }

  async selectAsset() {
    this._activityDaysServiceProxy
      .getAllControllingAccountsToBeAssigned(
        null,
        null,
        this.activityDayId,
        null,
        0,
        999999
      )
      .subscribe((controllingStructure) => {
        this.controllingStructure = controllingStructure.items;
        this.controlsFormCtrl.setValue(controllingStructure.items);
        this.filteredControls.next(controllingStructure.items);

        this.onAssignedCounterUpdate.emit(this.controllingStructure.id);

        this.cdr.detectChanges();
        this.setInitialControlsSelector();
      });
  }

  selectControl(control) {
    let asset = this.assetsToBeAssigned.find(a => a.asset.id == control.controllingStructure.assetId);
    
    if(asset && asset.asset && asset.asset.code){
      this.assetCode = asset.asset.code;
    }
    const params = new UpdateControllingStructureForActivityDayInput({
      activityDayId: this.activityDayId,
      controllingAccountId: control.controllingStructure.id,
      assetId: asset.asset.id
    });
    this._activityDaysServiceProxy
      .updateControllingStructure(params)
      .subscribe(() => {
        this.controllingStructureCode = control.controllingStructure.accId;
        this.isAssetModified = true;
        this.onAssignedCounterUpdate.emit(this.controllingStructureCode);
      });
  }

  ngAfterViewInit() {
    this.setInitialControlsSelector();
  }

  setInitialControlsSelector() {
    this.filteredControls
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.controlsSelector.compareWith = (a: any, b: any) => {
          return a && b && a.id === b.id;
        };
      });
  }

  protected filterControls() {
    if (!this.controllingStructure) {
      return;
    }

    let search = this.controlsFilterForm.value;
    if (!search) {
      this.filteredControls.next(this.controllingStructure.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredControls.next(
      this.controllingStructure?.filter(
        (asset) =>
          asset.controllingStructure.name.toLowerCase().indexOf(search) > -1 ||
          asset.controllingStructure.accId.toLowerCase().indexOf(search) > -1
      )
    );
  }

  ClearRecent(): void {

      this._activityDaysServiceProxy.clearActivityDayControllingRecent()
      .subscribe(() => {
        this.controllingStructure.forEach(asst => {
          asst.wasRecentlyAssigned = false;
        })
                      
        this.cdr.detectChanges();
    });
  }

  applyAll(activityDayId: string) {
    const params = new CopyControllingStructureToAllActivityDaysInput({
      activityDayId,
    });
    this._activityDaysServiceProxy
      .copyControllingStructureToAll(params)
      .subscribe(() => {
        this.notify.success(this.l('AssetAndControlAppliedToAll'));
      });
  }
}
